import { initializeApp } from "firebase/app";
import { getAnalytics, Analytics } from "firebase/analytics";
import {
  getMessaging,
  getToken,
  deleteToken,
  isSupported,
  Messaging,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics instance helper
let analytics: Analytics | null = null;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

// Initialize Messaging instance helper
let messaging: Messaging | null = null;
let messagingPromise: Promise<Messaging | null> | null = null;

export const getMessagingInstance = async (): Promise<Messaging | null> => {
  if (typeof window === "undefined") return null;
  if (messaging) return messaging;

  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((supported) => {
        if (supported) {
          messaging = getMessaging(app);
          return messaging;
        }
        return null;
      })
      .catch((err) => {
        console.warn("Firebase Messaging initialization check failed:", err);
        return null;
      });
  }

  return messagingPromise;
};

export { messaging, analytics };

export const requestForToken = async () => {
  const m = await getMessagingInstance();
  if (!m) return null;

  try {
    const currentToken = await getToken(m, {
      vapidKey: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_VAPID_KEY,
    });

    if (currentToken) {
      return currentToken;
    } else {
      console.log(
        "No registration token available. Request permission to generate one.",
      );
      return null;
    }
  } catch (err) {
    console.log("An error occurred while retrieving token. ", err);
    return null;
  }
};

export const deleteFCMToken = async () => {
  const m = await getMessagingInstance();
  if (!m) return false;
  try {
    await deleteToken(m);
    return true;
  } catch (err) {
    console.log("Unable to delete token. ", err);
    return false;
  }
};
